import { PermissionsUser, SubRole } from '../services/auth.service';
import { LocalStorageService } from '../services/local-storage.service';
import { tryJsonParse } from './string';
/**
 * Valida el acceso a un módulo y submódulo específico.
 * @param moduleName - Nombre del módulo.
 * @param subModule - Nombre del submódulo.
 * @returns `true` si el usuario tiene acceso, de lo contrario `false`.
 */
export const validateAccess = (moduleName: string, subModule?: string) => {
	const ls = new LocalStorageService();

	if (ls.isAdminRole) {
		return ls.isAdminRole;
	}

	/*
		Se hace una excepción para el módulo de servicios,
		cualquier usuario puede acceder a este módulo.
		En futuras versiones se debe validar estos permisos a nivel de backend.
	*/
	if(moduleName === 'servicios') return true;

	const userPermissions = tryJsonParse<PermissionsUser>(ls.getItem('permissions'));
	if (userPermissions[moduleName]) {
		if (userPermissions[moduleName].submodules.length === 0) {
			return userPermissions[moduleName].access;
		}
		if (subModule) {
			const subm = userPermissions[moduleName].submodules.find(m => m.name === subModule);
			return subm?.access ?? false;
		}
		return userPermissions[moduleName].access;
	}

	return ls.isAdminRole ?? false;
};


/**
 * Valida el acceso a una acción específica en un submódulo.
 * @param moduleName - Nombre del módulo.
 * @param submodule - Nombre del submódulo.
 * @param action - Acción a validar.
 * @returns `true` si el usuario tiene acceso, de lo contrario `false`.
 */
export const validateSubRole = (moduleName: string, submodule: string | null, action: string) => {
	const ls = new LocalStorageService();

	if (ls.isAdminRole) {
		return ls.isAdminRole;
	}
	const userSubroles = tryJsonParse<SubRole[]>(ls.getItem('subroles'));
	const permission = userSubroles.find(r => r.module === moduleName && r.submodule === submodule && r.action === action);

	return !!permission;
};
